import {
    redirect,
    Navigate
  } from "react-router-dom";
  import {localStorageUserKey} from '../local_storage_vars'; 
  import { smartStorage } from "../smart_storage";

const GuestRequire = ({children})=>{
    const user = smartStorage.get(localStorageUserKey); 

    if(user){
        return <Navigate to={'/home'} />
    }else{
        return children
    }
}

export default GuestRequire